/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Fragment } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { AppStyles } from "../../assets/styles/App"
import Header from "../gatsby/Header"
import "@wordpress/block-library/build-style/style.css"
import "assets/styles/styles.css"

const Layout: React.FC<Node | any> = ({ children }) => {
  const classes = AppStyles()

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        buildTime(formatString: "YYYY-MM-DD HH:mm")
        siteMetadata {
          title
          description
          basePath
        }
      }
    }
  `)

  const { title, description } = data.site.siteMetadata
  const { buildTime } = data.site

  return (
    <Fragment>
      <div className={classes.fixed}>
        <Header title={title} />
      </div>
      {children}
      {/* <footer className="footer">
        <div className="content has-text-right has-text-weight-light has-text-grey-light">
          <p>Build: {buildTime}</p>
        </div>
      </footer> */}
    </Fragment>
  )
}

export default Layout
